import { TableRow, TableCell, Box, IconButton } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PropTypes from "prop-types";

const HistoryRow = ({ game, onDelete }) => {
  const handleGameDelete = () => onDelete(game.id);

  return (
    <TableRow>
      <TableCell align="center">{game.deck}</TableCell>
      <TableCell align="center">{game.opponent}</TableCell>
      <TableCell align="center">{game.order}</TableCell>
      <TableCell align="center">{game.result}</TableCell>
      <TableCell>{game.notes}</TableCell>

      <TableCell>
        <Box display="flex" justifyContent="space-around">
          {onDelete && (
            <IconButton onClick={handleGameDelete}>
              <DeleteForeverIcon color="error" />
            </IconButton>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
};

HistoryRow.propTypes = {
  game: PropTypes.object,
  onDelete: PropTypes.func,
};

export default HistoryRow;
